import React, { Suspense } from 'react';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';

import Home from "screens/Home";

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<>Loading ...</>}>
        <Routes>
          <Route path="/:id" element={<Home />} />
          <Route path="/" element={<Navigate to="/2" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
